import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Stepper, Button, Group, Checkbox, TextInput, Radio, Title, Text, Select, CloseButton, Notification, Tooltip, Modal, Textarea } from '@mantine/core';
import { MdOutlineAlternateEmail, MdOutlineDateRange, MdOutlinePhoneEnabled } from "react-icons/md";
import { GrDocumentText } from "react-icons/gr";
import { Link, useNavigate } from 'react-router-dom';
import UploadFile from '../../shared/UploadFile';
import { DateInput } from '@mantine/dates';
import { getData, postData } from 'views/Website/services/fetch-service';
import { FaCheck, FaInfoCircle } from 'react-icons/fa';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import Values from './Values';
import dayjs from 'dayjs';
import CopyToClipboard from 'react-copy-to-clipboard';
import { RxCross1 } from 'react-icons/rx';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const Deklarimi = () => {
    const [active, setActive] = useState(0);
    const prevStep = () => setActive((current) => (current > 0 ? current - 1 : current));
    const [checkedItems, setCheckedItems] = useState({});
    const [deklarimiLlojiDeklarimitPasurise, setDeklarimiLlojiDeklarimitPasurise] = useState([]);

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const institutionsData = useSelector((state) => state.WebsiteLanguage.data.Instuticionet);
    const [llojiDeklarimit, setLlojiDeklarimit] = useState([]);
    const [llojiDhuratave, setLlojiDhuratave] = useState([]);
    const [idDeklarimi, setIdDeklarimi] = useState();
    const [referenceDeklarimi, setReferenceDeklarimi] = useState();
    const WebsiteLanguage = useSelector((state) => state.WebsiteLanguage.data.language);
    const GeneralTranslations = useSelector((state) => state.WebsiteLanguage.data.GeneralTranslations);
    const ControlsTranslations = useSelector((state) => state.WebsiteLanguage.data.ControlsTranslations);
    const ContentTranslations = useSelector((state) => state.WebsiteLanguage.data.ContentTranslations);
    const ValidationTranslations = useSelector((state) => state.WebsiteLanguage.data.ValidationTranslations);
    const AlertTranslations = useSelector((state) => state.WebsiteLanguage.data.AlertTranslations);
    const baseUrl = process.env.REACT_APP_BASEURL

    let nameLocale = '';
    let pershkrimiLocale = '';
    let othersLocale = '';
    const maxChars = 2500;

    if (WebsiteLanguage === 'sq') {
        nameLocale = 'nameSq';
        pershkrimiLocale = 'pershkrimiSq';
        othersLocale = 'Tjetër';
    } else if (WebsiteLanguage === 'en') {
        nameLocale = 'nameEn';
        pershkrimiLocale = 'pershkrimiEn';
        othersLocale = 'Other';
    } else if (WebsiteLanguage === 'sr') {
        nameLocale = 'nameSr';
        pershkrimiLocale = 'pershkrimiSr';
        othersLocale = 'Ostalo';
    } else {
        nameLocale = 'nameSq';
        pershkrimiLocale = 'pershkrimiSq';
        othersLocale = 'Tjetër';
    };

    const fetchLlojiDeklarimit = async () => {
        try {
            const response = await getData(`Home/GetLlojiDeklarimitTePasurise`);
            if (response.data) {
                setLlojiDeklarimit(response.data);
            }
        } catch (error) {
            setLlojiDeklarimit();

        }
    }

    const handleCloseButtonClick = () => {
        setNotificationBox(null);
    }

    const fetchLlojiDeklarimitDhuratave = async () => {
        try {
            const response = await getData(`Home/GetLlojiDeklarimitTeDhuratave`);
            if (response.data) {
                setLlojiDhuratave(response.data);
            }
        } catch (error) {
            setLlojiDhuratave();

        }
    }

    useEffect(() => {
        fetchLlojiDeklarimit();
        fetchLlojiDeklarimitDhuratave();
    }, []);

    const getValidationSchema = (activeStep) => {
        if (activeStep === 0) {
            return Yup.object().shape({
                raportuesiEmri: Yup.string().when('raportuesiAnonim', {
                    is: 'false',
                    then: Yup.string().nullable().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string().nullable(),
                }),
                raportuesiMbiemri: Yup.string().when('raportuesiAnonim', {
                    is: 'false',
                    then: Yup.string().nullable().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string().nullable(),
                }),
                // raportuesiEmail: Yup.string().email(ValidationTranslations.validEmail).required(ValidationTranslations.requiredField),
                // ConfirmEmailRaportuesi: Yup.string().email(ValidationTranslations.validEmail)
                //     .oneOf([Yup.ref('raportuesiEmail'), null], ValidationTranslations.confirmEmail)
                //     .required(ValidationTranslations.requiredField),
                raportuesiGjiniaId: Yup.string().required(ValidationTranslations.requiredField).nullable(),
            });
        } else if (activeStep === 1) {
            return Yup.object().shape({
                zyrtariEmri: Yup.string().required(ValidationTranslations.requiredField),
                zyrtariMbiemri: Yup.string().required(ValidationTranslations.requiredField),
                zyrtariEmail: Yup.string().email(ValidationTranslations.validEmail),
                zyrtariGjiniaId: Yup.string().required(ValidationTranslations.requiredField),
                zyrtariInstitucioniId: Yup.string().required(ValidationTranslations.requiredField),
                zyrtariInstitucioniTjera: Yup.string().when('zyrtariInstitucioniId', {
                    is: '-1',
                    then: Yup.string().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string(),
                }),
                zyrtariPozitaPunes: Yup.string().required(ValidationTranslations.requiredField),

                LlojiShkeljes: Yup.string().required(ValidationTranslations.requiredField),
                llojiDeklarimitTeDhurataveId: Yup.string().when('LlojiShkeljes', {
                    is: '2',
                    then: Yup.string().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string(),
                }),
                pershkrimiDhurates: Yup.string().when('LlojiShkeljes', {
                    is: '2',
                    then: Yup.string().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string(),
                }),
                pershkrimi: Yup.string().required(ValidationTranslations.requiredField),
            });
        }

        return Yup.object();
    };

    const handleCheckboxChange = (value, option) => {
        setCheckedItems((prevCheckedItems) => ({
            ...prevCheckedItems,
            [value]: !prevCheckedItems[value],
        }));

        if (!checkedItems[value]) {
            setDeklarimiLlojiDeklarimitPasurise((prevList) => [
                ...prevList,
                {
                    deklarimiId: 0,
                    llojiDeklarimitPasuriseId: option.id,
                    pershkrimi: '',
                },
            ]);
        } else {
            setDeklarimiLlojiDeklarimitPasurise((prevList) =>
                prevList.filter((item) => item.llojiDeklarimitPasuriseId !== option.id)
            );
        }
    };

    const handleInputChange = (value, inputValue) => {
        setDeklarimiLlojiDeklarimitPasurise((prevList) =>
            prevList.map((item) =>
                item.llojiDeklarimitPasuriseId === value ? { ...item, pershkrimi: inputValue } : item
            )
        );
    };

    const handlePopup = () => {
        navigate('/');
    };

    const handlePaste = (event) => {
        event.preventDefault();
        return false;
    };

    const institutionsDataWithStringValues = institutionsData.map(item => ({
        value: `${item.id}`,
        label: item[nameLocale],
    }));

    institutionsDataWithStringValues.push({
        value: '-1',
        label: othersLocale
    });
    const formik = useFormik({
        initialValues: {
            raportuesiAnonim: 'false',
            raportuesiEmri: null,
            raportuesiMbiemri: null,
            raportuesiEmail: '',
            ConfrimEmailRaportuesi: '',
            raportuesiGjiniaId: null,

            zyrtariEmail: '',
            zyrtariEmri: '',
            zyrtariNrTel: '',
            zyrtariMbiemri: '',
            zyrtariGjiniaId: '',
            zyrtariInstitucioniId: '',
            zyrtariInstitucioniTjera: '',
            zyrtariPozitaPunes: '',
            LlojiShkeljes: '',
            llojiDeklarimitTeDhurataveId: '',
            pershkrimiDhurates: '',

            pershkrimi: ''
        },
        validationSchema: getValidationSchema(active),
        onSubmit: (values) => {
            let controlZyrtariInstitucioniId = values;
            if (values.zyrtariInstitucioniId === '-1') {
                controlZyrtariInstitucioniId = { ...values, zyrtariInstitucioniId: null }
            }

            let controlLlojiShkeljes = controlZyrtariInstitucioniId;
            if (values.LlojiShkeljes === '1') {
                controlLlojiShkeljes = {
                    ...controlZyrtariInstitucioniId,
                    mosDeklarimiPasurise: true,
                    mosDeklarimiDhuratave: false,
                    llojiDeklarimitTeDhurataveId: null,
                    deklarimiLlojiDeklarimitPasurise: deklarimiLlojiDeklarimitPasurise,
                }
            } else if (values.LlojiShkeljes === '2') {
                controlLlojiShkeljes = { ...controlZyrtariInstitucioniId, mosDeklarimiDhuratave: true, mosDeklarimiPasurise: false }
            }

            let anonimControll = controlLlojiShkeljes;
            if (values.raportuesiAnonim === 'false') {
                anonimControll = { ...controlLlojiShkeljes, raportuesiAnonim: false }
            } else if (values.raportuesiAnonim === 'true') {
                anonimControll = { ...controlLlojiShkeljes, raportuesiAnonim: true }
            }

            let raportuesiGjiniaIdControll = anonimControll;

            if (values.raportuesiGjiniaId) {
                raportuesiGjiniaIdControll = {
                    ...anonimControll,
                    raportuesiGjiniaId: parseInt(values.raportuesiGjiniaId, 10),
                };
            }

            let zyrtariGjiniaIdControll = raportuesiGjiniaIdControll;

            if (values.zyrtariGjiniaId) {
                zyrtariGjiniaIdControll = {
                    ...raportuesiGjiniaIdControll,
                    zyrtariGjiniaId: parseInt(values.zyrtariGjiniaId, 10),
                };
            }

            let llojiDeklarimitTeDhurataveIdControll = zyrtariGjiniaIdControll;

            if (values.llojiDeklarimitTeDhurataveId) {
                llojiDeklarimitTeDhurataveIdControll = {
                    ...zyrtariGjiniaIdControll,
                    llojiDeklarimitTeDhurataveId: parseInt(values.llojiDeklarimitTeDhurataveId, 10),
                };
            }
            let datePranimitDhurates = llojiDeklarimitTeDhurataveIdControll
            if (values.dataPranimitDhurates) {
                const formattedDate = dayjs(values.dataSinjalizimit).format('YYYY-MM-DD');
                datePranimitDhurates = { ...llojiDeklarimitTeDhurataveIdControll, dataPranimitDhurates: `${formattedDate}` };
            } else {
                datePranimitDhurates = { ...llojiDeklarimitTeDhurataveIdControll, dataPranimitDhurates: null };
            }

            postDeklarimi(datePranimitDhurates)
        },
    });

    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileError, setSelectedFileError] = useState(false);
    const [documentName, setDocumentName] = useState('');
    const [documentType, setDocumentType] = useState('');
    const [savedDocuments, setSavedDocuments] = useState([]);
    const [documentsModelOpen, setDocumentsModelOpen] = useState(false);
    const [deleteDocumentsIndex, setDeleteDocumentsIndex] = useState(null);

    const [NotificationBox, setNotificationBox] = useState(null);
    const [languageValue, setLanguageValue] = useState(1);
    const [checkMediaError, setCheckMediaError] = useState(false);

    useEffect(() => {
        const languageMap = {
            'sq': 1,
            'en': 2,
            'sr': 3
        };

        setLanguageValue(languageMap[WebsiteLanguage]);
    }, [WebsiteLanguage]);

    const handleFileChange = async (file) => {
        try {
            const lastDotIndex = file.name.lastIndexOf('.');
            const fileType = file.name.slice(lastDotIndex);

            const checkMedia = await getData(`Deklarimi/CheckMedia?size=${file.size}&format=${fileType}&webLang=${languageValue}`);

            if (checkMedia && checkMedia.status === 200) {
                setSelectedFile(file);
            } else {
                setCheckMediaError(true);
                setSelectedFileError(true);
                throw new Error('Error invalid file');
            }
        } catch (error) {
            setCheckMediaError(true);
            setSelectedFileError(true);
            setNotificationBox(
                <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                    {AlertTranslations.CheckMediaErrorAlert}
                </Notification>
            );
            setTimeout(() => {
                setNotificationBox(null);
                setCheckMediaError(false);
                setSelectedFileError(false);
            }, 5000);
            setSelectedFile(null);
        }
    };

    const handleSave = async () => {
        try {
            if (selectedFile && documentName) {
                const updatedFile = new Blob([selectedFile], { type: selectedFile.type });
                updatedFile.name = documentName + documentType;

                const newDocument = {
                    file: updatedFile,
                };

                setSavedDocuments((prevDocuments) => [...prevDocuments, newDocument]);
                setSelectedFile(null);
                setDocumentName('');
                setDocumentType('');
                setSelectedFileError(false);
            }
        } catch (error) {
            setSelectedFile(null);
            setDocumentName('');
            setDocumentType('');
            setSelectedFileError(false);

            if (error.response && error.response.data) {
                setNotificationBox(
                    <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                        {error.response.data[0].message}
                    </Notification>
                );
                setTimeout(() => {
                    setNotificationBox(null);
                }, 5000);
            }
        }
    };

    const postDeklarimi = async (data) => {
        try {
            const newData = {
                ...data,
                Gjuha: WebsiteLanguage,
            }
            const deklarimiResponse = await postData('Deklarimi/CreateDeclaration', newData);
            if (deklarimiResponse) {
                setIdDeklarimi(deklarimiResponse.data.raportimets[0].id)
                setReferenceDeklarimi(deklarimiResponse.data.raportimets[0].referenca)
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            setNotificationBox(
                <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                    {AlertTranslations.notifyError}
                </Notification>
            );
            setTimeout(() => {
                setNotificationBox(null);
            }, 5000);
        }
    };

    const deklarimiMedia = async () => {

        try {
            const data = {
                Files: savedDocuments,
                RaportimiId: idDeklarimi,
            };

            let formData = new FormData();
            data.Files.forEach((doc) => {
                formData.append('Files', doc.file, doc.file.name);
            });

            formData.append('RaportimiId', data.RaportimiId);
            formData.append('Publik', true);

            const deklarimiResponseMedia = await postData('Deklarimi/InsertRaportimetMedia', formData);

            if (deklarimiResponseMedia) {
                setIsLoading(false);
            }

        } catch (error) {
            setIsLoading(false);
            setNotificationBox(
                <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                    {AlertTranslations.notifyError}
                </Notification>
            );
            setTimeout(() => {
                setNotificationBox(null);
            }, 5000);
        }
    };

    useEffect(() => {
        if (idDeklarimi && savedDocuments && savedDocuments.length > 0) {
            deklarimiMedia();
        }
    }, [idDeklarimi, savedDocuments]);

    const handleNextStep = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                if (active === 1) {
                    if (selectedFile && !savedDocuments.some((doc) => doc.file === selectedFile)) {
                        setSelectedFileError(true);
                        setNotificationBox(
                            <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                                {AlertTranslations.notifyFileRequired}
                            </Notification>
                        );
                        setTimeout(() => {
                            setNotificationBox(null);
                        }, 3000);
                        return;
                    }

                    setIsLoading(true);
                    formik.handleSubmit();
                    setTimeout(() => {
                        setActive(2);
                    }, 3000);
                } else if (active < 2) {
                    setActive((current) => current + 1);
                }
            } else {
                const raportuesiEmailError = formik.errors.raportuesiEmail;
                if (raportuesiEmailError) {
                    formik.setErrors({
                        ...formik.errors,
                        ConfirmEmailRaportuesi: raportuesiEmailError,
                    });

                    formik.setTouched({
                        ...formik.touched,
                        ConfirmEmailRaportuesi: true,
                    });
                }

                formik.setTouched(
                    Object.keys(formik.values).reduce((acc, key) => {
                        acc[key] = true;
                        return acc;
                    }, {})
                );
            }
        });
    };


    const handleDelete = (index) => {
        setDeleteDocumentsIndex(index);
        setDocumentsModelOpen(true);
    };

    const confirmDeleteDocuments = () => {
        if (deleteDocumentsIndex !== null) {
            const updatedDocuments = [...savedDocuments];
            updatedDocuments.splice(deleteDocumentsIndex, 1);
            setSavedDocuments(updatedDocuments);
        }
        closeModalDocuments();
    };

    const closeModalDocuments = () => {
        setDocumentsModelOpen(false);
        setDeleteDocumentsIndex(null);
    };

    useEffect(() => {
        if (selectedFile) {
            const lastDotIndex = selectedFile.name.lastIndexOf('.');
            const nameWithoutExtension = selectedFile.name.slice(0, lastDotIndex);
            const fileType = selectedFile.name.slice(lastDotIndex);
            setDocumentName(nameWithoutExtension);
            setDocumentType(fileType);
        }
    }, [selectedFile])

    const clearInputValue = () => {
        setDocumentName('');
        setDocumentType('');
        setSelectedFile(null);
        setSelectedFileError(false);
    };

    return (
        <div className="apk-home">
            <div className="stepper-container">
                <div className="stepper-header deklarimi-steps">
                    <Stepper allowNextStepsSelect={false} color="#051A53" active={active} onStepClick={setActive}>
                        <Stepper.Step label={ContentTranslations.step1Name} description={ContentTranslations.step1DeklarimiDescription}>
                            <div className="form-container">
                                <div className="form-section">
                                    <Title className="form-title" order={2}>
                                        <div className='icone'>
                                            {GeneralTranslations.step1DeklarimiSubTitle}
                                            <Tooltip
                                                multiline
                                                sx={{ maxWidth: 500 }}
                                                position="top"
                                                className="tooltip-konflikt"
                                                withArrow arrowSize={8} label={AlertTranslations.DeklarimiTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle size="18px" />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </Title>
                                    <Text className="form-desc" size="lg">
                                        <div className='icone'>
                                            {GeneralTranslations.ReporterData}
                                            <Tooltip multiline sx={{ maxWidth: 500 }} withArrow arrowSize={8} label={AlertTranslations.DeklarimiDataTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle size="18px" />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </Text>
                                </div>

                                <Radio.Group
                                    name="raportuesiAnonim"
                                    label={
                                        <div className='icone'>
                                            {GeneralTranslations.anonymous}
                                            <Tooltip withArrow arrowSize={8} label={AlertTranslations.DeklarimiAnonimTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div>}
                                    value={formik.values.raportuesiAnonim}
                                    onChange={(value) => formik.setFieldValue('raportuesiAnonim', value)}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.raportuesiAnonim && formik.errors.raportuesiAnonim}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                >
                                    <Group mt="xs">
                                        <Radio color="#051A53" value="false" label={ControlsTranslations.no} />
                                        <Radio color="#051A53" value="true" label={ControlsTranslations.yes} />
                                    </Group>
                                </Radio.Group>
                                <Group grow className="name-group">
                                    <TextInput
                                        label={GeneralTranslations.name}
                                        placeholder={GeneralTranslations.name}
                                        name="raportuesiEmri"
                                        required={formik.values.raportuesiAnonim === "false" ? true : false}
                                        onChange={formik.handleChange}
                                        value={formik.values.raportuesiEmri}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.raportuesiEmri && formik.errors.raportuesiEmri}
                                        inputWrapperOrder={['label', 'error', 'input']}
                                        rightSection={
                                            <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiNameTooltip} color="#051A53">
                                                <div className="icone">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        }
                                    />
                                    <TextInput
                                        label={GeneralTranslations.lastName}
                                        name="raportuesiMbiemri"
                                        placeholder={GeneralTranslations.lastName}
                                        required={formik.values.raportuesiAnonim === "false" ? true : false}
                                        onChange={formik.handleChange}
                                        value={formik.values.raportuesiMbiemri}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.raportuesiMbiemri && formik.errors.raportuesiMbiemri}
                                        inputWrapperOrder={['label', 'error', 'input']}
                                        rightSection={
                                            <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiMbiemriTooltip} color="#051A53">
                                                <div className="icone">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        }
                                    />
                                </Group>
                                <TextInput
                                    label={GeneralTranslations.numriTelefonit}
                                    placeholder={GeneralTranslations.numriTelefonit}
                                    leftSectionPointerEvents="none"
                                    type="tel"
                                    name='raportuesiNrTel'
                                    onChange={(e) => formik.setFieldValue('raportuesiNrTel', e.target.value)}
                                    value={formik.values.raportuesiNrTel}
                                    leftSection={<MdOutlinePhoneEnabled />}
                                    rightSection={
                                        <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiTelTooltip} color="#051A53">
                                            <div className="icone">
                                                <FaInfoCircle />
                                            </div>
                                        </Tooltip>
                                    }
                                />
                                <TextInput
                                    leftSectionPointerEvents="none"
                                    leftSection={<MdOutlineAlternateEmail />}
                                    label={GeneralTranslations.emailAddress}
                                    // required
                                    name='raportuesiEmail'
                                    placeholder={GeneralTranslations.emailAddress}
                                    onChange={formik.handleChange}
                                    value={formik.values.raportuesiEmail}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.raportuesiEmail && formik.errors.raportuesiEmail}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                    rightSection={
                                        <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiEmailTooltip} color="#051A53">
                                            <div className="icone">
                                                <FaInfoCircle />
                                            </div>
                                        </Tooltip>
                                    }
                                />
                                <TextInput
                                    leftSectionPointerEvents="none"
                                    leftSection={<MdOutlineAlternateEmail />}
                                    label={ContentTranslations.ConfirmEmail}
                                    // required
                                    name='ConfirmEmailRaportuesi'
                                    onChange={formik.handleChange}
                                    onPaste={handlePaste}
                                    value={formik.values.ConfirmEmailRaportuesi}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.raportuesiEmail && formik.errors.ConfirmEmailRaportuesi}
                                    placeholder={ContentTranslations.ConfirmEmail}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                    rightSection={
                                        <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiEmailTooltip} color="#051A53">
                                            <div className="icone">
                                                <FaInfoCircle />
                                            </div>
                                        </Tooltip>
                                    }
                                />

                                <Radio.Group
                                    label={
                                        <div className='icone'>
                                            {GeneralTranslations.gender}
                                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                            <Tooltip multiline w={300} withArrow arrowSize={8} label={AlertTranslations.KonfliktiGjiniaTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div>}
                                    name='raportuesiGjiniaId'
                                    //withAsterisk={formik.values.raportuesiAnonim === "false" ? true : false}
                                    value={formik.values.raportuesiGjiniaId}
                                    onChange={(value) => formik.setFieldValue('raportuesiGjiniaId', value)}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.raportuesiGjiniaId && formik.errors.raportuesiGjiniaId}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                >
                                    <Group mt="xs">
                                        <Radio color="#051A53" value="1" label="M" />
                                        <Radio color="#051A53" value="2" label="F" />
                                    </Group>
                                </Radio.Group>
                                <Values values={formik.values} />
                            </div>
                        </Stepper.Step>
                        <Stepper.Step label={ContentTranslations.step2Name} description={GeneralTranslations.step2DeklarimiDescription}>
                            <div className="form-container">
                                <div className="form-section">
                                    <Title className="form-title" order={2}>{GeneralTranslations.DeklarimiPasurise}</Title>
                                    <Text className="form-desc" size="lg">{GeneralTranslations.step2DeklarimiSubTitle}</Text>
                                </div>
                                <Values values={formik.values} />
                                <Group grow className="name-group">
                                    <TextInput
                                        label={GeneralTranslations.name}
                                        name="zyrtariEmri"
                                        placeholder={GeneralTranslations.name}
                                        required
                                        onChange={formik.handleChange}
                                        value={formik.values.zyrtariEmri}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.zyrtariEmri && formik.errors.zyrtariEmri}
                                        inputWrapperOrder={['label', 'error', 'input']}
                                        rightSection={
                                            <Tooltip withArrow arrowSize={8} label={AlertTranslations.DeklarimiEmriTooltip} color="#051A53">
                                                <div className="icone">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        }
                                    />
                                    <TextInput
                                        label={GeneralTranslations.lastName}
                                        placeholder={GeneralTranslations.lastName}
                                        name="zyrtariMbiemri"
                                        required
                                        onChange={formik.handleChange}
                                        value={formik.values.zyrtariMbiemri}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.zyrtariMbiemri && formik.errors.zyrtariMbiemri}
                                        inputWrapperOrder={['label', 'error', 'input']}
                                        rightSection={
                                            <Tooltip withArrow arrowSize={8} label={AlertTranslations.DeklarimiMbiemriTooltip} color="#051A53">
                                                <div className="icone">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        }
                                    />
                                </Group>
                                <TextInput
                                    label={GeneralTranslations.numriTelefonit}
                                    placeholder={GeneralTranslations.numriTelefonit}
                                    leftSectionPointerEvents="none"
                                    type="tel"
                                    name='zyrtariNrTel'
                                    onChange={(e) => formik.setFieldValue('zyrtariNrTel', e.target.value)}
                                    value={formik.values.zyrtariNrTel}
                                    leftSection={<MdOutlinePhoneEnabled />}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                    rightSection={
                                        <Tooltip withArrow arrowSize={8} label={AlertTranslations.DeklarimiTelTooltip} color="#051A53">
                                            <div className="icone">
                                                <FaInfoCircle />
                                            </div>
                                        </Tooltip>
                                    }
                                />
                                <TextInput
                                    leftSectionPointerEvents="none"
                                    leftSection={<MdOutlineAlternateEmail />}
                                    label={GeneralTranslations.emailAddress}
                                    placeholder={GeneralTranslations.emailAddress}
                                    name='zyrtariEmail'
                                    onChange={(e) => formik.setFieldValue('zyrtariEmail', e.target.value)}
                                    value={formik.values.zyrtariEmail}
                                    error={formik.errors.zyrtariEmail}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                    rightSection={
                                        <Tooltip withArrow arrowSize={8} label={AlertTranslations.DeklarimiEmailTooltip} color="#051A53">
                                            <div className="icone">
                                                <FaInfoCircle />
                                            </div>
                                        </Tooltip>
                                    }
                                />
                                <Radio.Group
                                    label={
                                        <div className='icone'>
                                            {GeneralTranslations.gender}
                                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                            <Tooltip multiline w={300} withArrow arrowSize={8} label={AlertTranslations.DeklarimiGjinia2Tolltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div>}
                                    name='zyrtariGjiniaId'
                                    value={formik.values.zyrtariGjiniaId}
                                    onChange={(value) => formik.setFieldValue('zyrtariGjiniaId', value)}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.zyrtariGjiniaId && formik.errors.zyrtariGjiniaId}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                    withAsterisk={false}
                                >
                                    <Group mt="xs">
                                        <Radio color="#051A53" value="1" label="M" />
                                        <Radio color="#051A53" value="2" label="F" />
                                    </Group>
                                </Radio.Group>
                                <Select
                                    searchable
                                    // clearable
                                    required
                                    key={WebsiteLanguage}
                                    data={institutionsDataWithStringValues}
                                    label={
                                        <div className='icone'>
                                            {GeneralTranslations.institutionLabel}
                                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                            <Tooltip multiline w={300} withArrow arrowSize={8} label={AlertTranslations.DeklarimiInstitucioniTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div>}
                                    placeholder={GeneralTranslations.institutionLabel}
                                    name='zyrtariInstitucioniId'
                                    onChange={(selected) => {
                                        formik.setFieldValue('zyrtariInstitucioniId', selected);
                                    }}
                                    value={formik.values.zyrtariInstitucioniId}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.zyrtariInstitucioniId && formik.errors.zyrtariInstitucioniId}
                                    withAsterisk={false}
                                // inputWrapperOrder={['label', 'error', 'select']}
                                />
                                {formik.values.zyrtariInstitucioniId === '-1' && (
                                    <TextInput
                                        label={GeneralTranslations.institutionName}
                                        required
                                        placeholder={GeneralTranslations.institutionName}
                                        name='zyrtariInstitucioniTjera'
                                        onChange={formik.handleChange}
                                        value={formik.values.zyrtariInstitucioniTjera}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.zyrtariInstitucioniTjera && formik.errors.zyrtariInstitucioniTjera}
                                        inputWrapperOrder={['label', 'error', 'input']}
                                    />
                                )}
                                <TextInput
                                    label={
                                        <div className='icone'>
                                            {GeneralTranslations.jobPosition}
                                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                            <Tooltip multiline w={400} withArrow arrowSize={8} label={AlertTranslations.DeklarimiJobTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div>}
                                    placeholder={GeneralTranslations.jobPosition}
                                    required
                                    name='zyrtariPozitaPunes'
                                    onChange={formik.handleChange}
                                    value={formik.values.zyrtariPozitaPunes}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.zyrtariPozitaPunes && formik.errors.zyrtariPozitaPunes}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                    withAsterisk={false}
                                />

                                <div className="form-section title-headings">
                                    <Text className="form-desc" size="lg">{GeneralTranslations.desriptionCase}</Text>
                                </div>

                                <Textarea
                                    rows={6}
                                    label={
                                        <div className='icone'>
                                            {GeneralTranslations.caseDescription}
                                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                            <Tooltip multiline w={500} withArrow arrowSize={8} label={AlertTranslations.DeklarimiPershkrimiTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    }
                                    placeholder={GeneralTranslations.caseDescription}
                                    required
                                    name='pershkrimi'
                                    onChange={(e) => {
                                        if (e.target.value.length <= maxChars) {
                                            formik.handleChange(e);
                                        }
                                    }}
                                    value={formik.values.pershkrimi}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.pershkrimi && formik.errors.pershkrimi}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                    withAsterisk={false}
                                />
                                <Text size="sm" color={formik.values.pershkrimi?.length === maxChars ? 'red' : 'gray'} style={{ marginTop: 4 }}>
                                    {formik.values.pershkrimi?.length}/{maxChars}
                                </Text>

                                <Radio.Group
                                    name="LlojiShkeljes"
                                    label={
                                        <div className='icone'>
                                            {GeneralTranslations.typeViolation}
                                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                            <Tooltip withArrow arrowSize={8} label={AlertTranslations.DeklarimiViolationTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div>}
                                    withAsterisk={false}
                                    value={formik.values.LlojiShkeljes}
                                    onChange={(value) => formik.setFieldValue('LlojiShkeljes', value)}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.LlojiShkeljes && formik.errors.LlojiShkeljes}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                >
                                    <Group mt="xs">
                                        <Radio color="#051A53" value="1" label={GeneralTranslations.nondeclarationAssets} />
                                        <Radio color="#051A53" value="2" label={GeneralTranslations.nondeclarationGifts} />
                                    </Group>
                                </Radio.Group>
                                {formik.values.LlojiShkeljes === "1" ? (
                                    <div className='deklarimi-checks'>
                                        {llojiDeklarimit.map((option, index) => (
                                            <React.Fragment key={index}>
                                                <Checkbox
                                                    value={option.id}
                                                    color="#051A53"
                                                    label={option[pershkrimiLocale]}
                                                    checked={checkedItems[option.id]}
                                                    onChange={() => handleCheckboxChange(option.id, option)}
                                                />
                                                {checkedItems[option.id] && (
                                                    <TextInput
                                                        label={GeneralTranslations.description}
                                                        placeholder={GeneralTranslations.description}
                                                        required
                                                        onChange={(e) => handleInputChange(option.id, e.target.value)}
                                                        inputWrapperOrder={['label', 'error', 'input']}
                                                    />
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </div>
                                ) : formik.values.LlojiShkeljes === "2" ? (
                                    <Fragment>
                                        <Radio.Group
                                            name="llojiDeklarimitTeDhurataveId"
                                            label={GeneralTranslations.typeGift}
                                            withAsterisk
                                            value={formik.values.llojiDeklarimitTeDhurataveId}
                                            onChange={(value) => formik.setFieldValue('llojiDeklarimitTeDhurataveId', value)}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.llojiDeklarimitTeDhurataveId && formik.errors.llojiDeklarimitTeDhurataveId}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                        >
                                            <Group mt="xs">
                                                {llojiDhuratave.map((option, index) => (
                                                    <Radio color="#051A53" key={index} value={`${option.id}`} label={option[pershkrimiLocale]} />
                                                ))}
                                            </Group>
                                        </Radio.Group>
                                        <TextInput
                                            label={GeneralTranslations.giftName}
                                            placeholder={GeneralTranslations.giftName}
                                            required
                                            name="pershkrimiDhurates"
                                            onChange={formik.handleChange}
                                            value={formik.values.pershkrimiDhurates}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.pershkrimiDhurates && formik.errors.pershkrimiDhurates}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                        />
                                        <TextInput
                                            label={GeneralTranslations.giftEuro}
                                            placeholder={GeneralTranslations.giftEuro}
                                            name="vleraDhurates"
                                            onChange={e => {
                                                const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                                                formik.setFieldValue('vleraDhurates', onlyNumbers);
                                            }}
                                            value={formik.values.vleraDhurates}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.vleraDhurates && formik.errors.vleraDhurates}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                        />
                                        <DateInput
                                            className="form-dateInput"
                                            valueFormat="DD/MM/YYYY"
                                            label={GeneralTranslations.timeGift}
                                            placeholder="DD/MM/YYYY"
                                            name='dataPranimitDhurates'
                                            clearable
                                            leftSectionPointerEvents="none"
                                            leftSection={<MdOutlineDateRange />}
                                            selected={formik.values.dataPranimitDhurates}
                                            value={formik.values.dataPranimitDhurates}
                                            onChange={(date) => formik.setFieldValue('dataPranimitDhurates', date)}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                        />
                                    </Fragment>
                                ) : (
                                    ''
                                )}
                                <div className="form-section title-headings">
                                    <Text className="form-desc" size="lg">
                                        <div className='icone'>
                                            {GeneralTranslations.listDocument}
                                            <Tooltip withArrow arrowSize={8} label={AlertTranslations.DeklarimiDokumetetTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle size="18px" />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </Text>
                                </div>
                                <Group mt="xs" className="doc-input-group">
                                    <UploadFile onFileChange={handleFileChange} />
                                    <Group>
                                        <TextInput
                                            leftSectionPointerEvents="none"
                                            leftSection={selectedFile ? <GrDocumentText /> : null}
                                            placeholder={GeneralTranslations.documentName}
                                            rightSection={
                                                selectedFile ? (
                                                    <CloseButton size="sm" variant="transparent" onClick={clearInputValue} />
                                                ) : null
                                            }
                                            className='doc-input'
                                            error={selectedFileError ? `${checkMediaError ? AlertTranslations.CheckMediaErrorAlert : AlertTranslations.notifyFileRequiredInput}` : ""}
                                            value={documentName}
                                            onChange={(e) => setDocumentName(e.target.value)}
                                        />
                                        {selectedFile &&
                                            <Button className="btn-add-doc form-btn btn-search-report" type="button" color="#051A53" onClick={handleSave}>{ControlsTranslations.Add}</Button>
                                        }
                                        <Tooltip withArrow arrowSize={8} label={AlertTranslations.MediaAllowedTooltip} color="#051A53">
                                            <div className="icone2">
                                                <FaInfoCircle size="18px" />
                                            </div>
                                        </Tooltip>
                                        {/* {selectedFile &&
                                            <ActionIcon color="#051A53" onClick={handleSave}><FaRegSave /></ActionIcon>
                                        } */}

                                    </Group>
                                </Group>

                                {savedDocuments.length > 0 && (
                                    <div className='document-list'>
                                        <Table sx={{ minWidth: 300 }} aria-label="simple table" className="table-raportimet">
                                            <TableHead>
                                                <TableRow className="header-table">
                                                    <TableCell className="header-th">{GeneralTranslations.numberTable}</TableCell>
                                                    <TableCell className="header-th">{GeneralTranslations.documentNameTable}</TableCell>
                                                    <TableCell className="header-th"></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {savedDocuments.map((doc, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell >{index + 1}</TableCell>
                                                        <TableCell >{doc.file.name}</TableCell>
                                                        <TableCell >  <Button size='xs' className="btn-clear-table" onClick={() => handleDelete(index)} >{ControlsTranslations.Delete}</Button></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </div>
                                )}
                            </div>
                        </Stepper.Step>
                        <Stepper.Completed>
                            <div className="form-container">
                                <div className="form-section">
                                    <Title className="form-title" order={2}>{GeneralTranslations.DeklarimiPasurise}</Title>
                                    <Text className="form-desc" size="lg">{GeneralTranslations.officialData}</Text>
                                </div>
                                <Values values={formik.values} />
                                <Group grow className="name-group">
                                    <TextInput
                                        label={GeneralTranslations.name}
                                        name="zyrtariEmri"
                                        placeholder={GeneralTranslations.name}
                                        required
                                        onChange={formik.handleChange}
                                        value={formik.values.zyrtariEmri}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.zyrtariEmri && formik.errors.zyrtariEmri}
                                        inputWrapperOrder={['label', 'error', 'input']}
                                        rightSection={
                                            <Tooltip withArrow arrowSize={8} label={AlertTranslations.DeklarimiEmriTooltip} color="#051A53">
                                                <div className="icone">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        }
                                    />
                                    <TextInput
                                        label={GeneralTranslations.lastName}
                                        placeholder={GeneralTranslations.lastName}
                                        name="zyrtariMbiemri"
                                        required
                                        onChange={formik.handleChange}
                                        value={formik.values.zyrtariMbiemri}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.zyrtariMbiemri && formik.errors.zyrtariMbiemri}
                                        inputWrapperOrder={['label', 'error', 'input']}
                                        rightSection={
                                            <Tooltip withArrow arrowSize={8} label={AlertTranslations.DeklarimiMbiemriTooltip} color="#051A53">
                                                <div className="icone">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        }
                                    />
                                </Group>
                                <TextInput
                                    label={GeneralTranslations.numriTelefonit}
                                    placeholder={GeneralTranslations.numriTelefonit}
                                    leftSectionPointerEvents="none"
                                    type="tel"
                                    name='zyrtariNrTel'
                                    onChange={(e) => formik.setFieldValue('zyrtariNrTel', e.target.value)}
                                    value={formik.values.zyrtariNrTel}
                                    leftSection={<MdOutlinePhoneEnabled />}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                    rightSection={
                                        <Tooltip withArrow arrowSize={8} label={AlertTranslations.DeklarimiTelTooltip} color="#051A53">
                                            <div className="icone">
                                                <FaInfoCircle />
                                            </div>
                                        </Tooltip>
                                    }
                                />
                                <TextInput
                                    leftSectionPointerEvents="none"
                                    leftSection={<MdOutlineAlternateEmail />}
                                    label={GeneralTranslations.emailAddress}
                                    placeholder={GeneralTranslations.emailAddress}
                                    name='zyrtariEmail'
                                    onChange={(e) => formik.setFieldValue('zyrtariEmail', e.target.value)}
                                    value={formik.values.zyrtariEmail}
                                    error={formik.errors.zyrtariEmail}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                    rightSection={
                                        <Tooltip withArrow arrowSize={8} label={AlertTranslations.DeklarimiEmailTooltip} color="#051A53">
                                            <div className="icone">
                                                <FaInfoCircle />
                                            </div>
                                        </Tooltip>
                                    }
                                />
                                <Radio.Group
                                    label={
                                        <div className='icone'>
                                            {GeneralTranslations.gender}
                                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                            <Tooltip multiline w={300} withArrow arrowSize={8} label={AlertTranslations.DeklarimiGjinia2Tolltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div>}
                                    name='zyrtariGjiniaId'
                                    value={formik.values.zyrtariGjiniaId}
                                    onChange={(value) => formik.setFieldValue('zyrtariGjiniaId', value)}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.zyrtariGjiniaId && formik.errors.zyrtariGjiniaId}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                    withAsterisk={false}
                                >
                                    <Group mt="xs">
                                        <Radio color="#051A53" value="1" label="M" />
                                        <Radio color="#051A53" value="2" label="F" />
                                    </Group>
                                </Radio.Group>
                                <Select
                                    searchable
                                    // clearable
                                    required
                                    key={WebsiteLanguage}
                                    data={institutionsDataWithStringValues}
                                    label={
                                        <div className='icone'>
                                            {GeneralTranslations.institutionLabel}
                                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                            <Tooltip multiline w={300} withArrow arrowSize={8} label={AlertTranslations.DeklarimiInstitucioniTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div>}
                                    placeholder={GeneralTranslations.institutionLabel}
                                    name='zyrtariInstitucioniId'
                                    onChange={(selected) => {
                                        formik.setFieldValue('zyrtariInstitucioniId', selected);
                                    }}
                                    value={formik.values.zyrtariInstitucioniId}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.zyrtariInstitucioniId && formik.errors.zyrtariInstitucioniId}
                                    withAsterisk={false}
                                // inputWrapperOrder={['label', 'error', 'select']}
                                />
                                {formik.values.zyrtariInstitucioniId === '-1' && (
                                    <TextInput
                                        label={GeneralTranslations.institutionName}
                                        required
                                        placeholder={GeneralTranslations.institutionName}
                                        name='zyrtariInstitucioniTjera'
                                        onChange={formik.handleChange}
                                        value={formik.values.zyrtariInstitucioniTjera}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.zyrtariInstitucioniTjera && formik.errors.zyrtariInstitucioniTjera}
                                        inputWrapperOrder={['label', 'error', 'input']}
                                    />
                                )}
                                <TextInput
                                    label={
                                        <div className='icone'>
                                            {GeneralTranslations.jobPosition}
                                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                            <Tooltip multiline w={400} withArrow arrowSize={8} label={AlertTranslations.DeklarimiJobTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div>}
                                    placeholder={GeneralTranslations.jobPosition}
                                    required
                                    name='zyrtariPozitaPunes'
                                    onChange={formik.handleChange}
                                    value={formik.values.zyrtariPozitaPunes}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.zyrtariPozitaPunes && formik.errors.zyrtariPozitaPunes}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                    withAsterisk={false}
                                />
                                <div className="form-section title-headings">
                                    <Text className="form-desc" size="lg">{GeneralTranslations.desriptionCase}</Text>
                                </div>
                                <Radio.Group
                                    name="LlojiShkeljes"
                                    label={
                                        <div className='icone'>
                                            {GeneralTranslations.typeViolation}
                                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                            <Tooltip withArrow arrowSize={8} label={AlertTranslations.DeklarimiViolationTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div>}
                                    withAsterisk={false}
                                    value={formik.values.LlojiShkeljes}
                                    onChange={(value) => formik.setFieldValue('LlojiShkeljes', value)}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.LlojiShkeljes && formik.errors.LlojiShkeljes}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                >
                                    <Group mt="xs">
                                        <Radio color="#051A53" value="1" label={GeneralTranslations.nondeclarationAssets} />
                                        <Radio color="#051A53" value="2" label={GeneralTranslations.nondeclarationGifts} />
                                    </Group>
                                </Radio.Group>
                                {formik.values.LlojiShkeljes === "1" ? (
                                    <div className='deklarimi-checks'>
                                        {llojiDeklarimit.map((option, index) => (
                                            <React.Fragment key={index}>
                                                <Checkbox
                                                    value={option.id}
                                                    color="#051A53"
                                                    label={option[pershkrimiLocale]}
                                                    checked={checkedItems[option.id]}
                                                    onChange={() => handleCheckboxChange(option.id, option)}
                                                />
                                                {checkedItems[option.id] && (
                                                    <TextInput
                                                        label={GeneralTranslations.description}
                                                        placeholder={GeneralTranslations.description}
                                                        required
                                                        onChange={(e) => handleInputChange(option.id, e.target.value)}
                                                        inputWrapperOrder={['label', 'error', 'input']}
                                                    />
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </div>
                                ) : formik.values.LlojiShkeljes === "2" ? (
                                    <Fragment>
                                        <Radio.Group
                                            name="llojiDeklarimitTeDhurataveId"
                                            label={GeneralTranslations.typeGift}
                                            withAsterisk
                                            value={formik.values.llojiDeklarimitTeDhurataveId}
                                            onChange={(value) => formik.setFieldValue('llojiDeklarimitTeDhurataveId', value)}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.llojiDeklarimitTeDhurataveId && formik.errors.llojiDeklarimitTeDhurataveId}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                        >
                                            <Group mt="xs">
                                                {llojiDhuratave.map((option, index) => (
                                                    <Radio color="#051A53" key={index} value={`${option.id}`} label={option[pershkrimiLocale]} />
                                                ))}
                                            </Group>
                                        </Radio.Group>
                                        <TextInput
                                            label={GeneralTranslations.giftName}
                                            placeholder={GeneralTranslations.giftName}
                                            required
                                            name="pershkrimiDhurates"
                                            onChange={formik.handleChange}
                                            value={formik.values.pershkrimiDhurates}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.pershkrimiDhurates && formik.errors.pershkrimiDhurates}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                        />
                                        <TextInput
                                            label={GeneralTranslations.giftEuro}
                                            placeholder={GeneralTranslations.giftEuro}
                                            name="vleraDhurates"
                                            onChange={e => {
                                                const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                                                formik.setFieldValue('vleraDhurates', onlyNumbers);
                                            }}
                                            value={formik.values.vleraDhurates}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.vleraDhurates && formik.errors.vleraDhurates}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                        />
                                        <DateInput
                                            className="form-dateInput"
                                            valueFormat="DD/MM/YYYY"
                                            label={GeneralTranslations.timeGift}
                                            placeholder="DD/MM/YYYY"
                                            name='dataPranimitDhurates'
                                            clearable
                                            leftSectionPointerEvents="none"
                                            leftSection={<MdOutlineDateRange />}
                                            selected={formik.values.dataPranimitDhurates}
                                            value={formik.values.dataPranimitDhurates}
                                            onChange={(date) => formik.setFieldValue('dataPranimitDhurates', date)}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                        />
                                    </Fragment>
                                ) : (
                                    ''
                                )}
                                <div className="form-section title-headings">
                                    <Text className="form-desc" size="lg">
                                        <div className='icone'>
                                            {GeneralTranslations.listDocument}
                                            <Tooltip withArrow arrowSize={8} label={AlertTranslations.DeklarimiDokumetetTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle size="18px" />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </Text>
                                </div>
                                <Group mt="xs" className="doc-input-group">
                                    <UploadFile onFileChange={handleFileChange} />
                                    <Group>
                                        <TextInput
                                            leftSectionPointerEvents="none"
                                            leftSection={selectedFile ? <GrDocumentText /> : null}
                                            placeholder={GeneralTranslations.documentName}
                                            rightSection={
                                                selectedFile ? (
                                                    <CloseButton size="sm" variant="transparent" onClick={clearInputValue} />
                                                ) : null
                                            }
                                            className='doc-input'
                                            error={selectedFileError ? `${checkMediaError ? AlertTranslations.CheckMediaErrorAlert : AlertTranslations.notifyFileRequiredInput}` : ""}
                                            value={documentName}
                                            onChange={(e) => setDocumentName(e.target.value)}
                                        />
                                        {selectedFile &&
                                            <Button className="btn-add-doc form-btn btn-search-report" type="button" color="#051A53" onClick={handleSave}>{ControlsTranslations.Add}</Button>
                                        }
                                        <Tooltip withArrow arrowSize={8} label={AlertTranslations.MediaAllowedTooltip} color="#051A53">
                                            <div className="icone2">
                                                <FaInfoCircle size="18px" />
                                            </div>
                                        </Tooltip>
                                        {/* {selectedFile &&
                                            <ActionIcon color="#051A53" onClick={handleSave}><FaRegSave /></ActionIcon>
                                        } */}

                                    </Group>
                                </Group>

                                {savedDocuments.length > 0 && (
                                    <div className='document-list'>
                                        <Table sx={{ minWidth: 300 }} aria-label="simple table" className="table-raportimet">
                                            <TableHead>
                                                <TableRow className="header-table">
                                                    <TableCell className="header-th">{GeneralTranslations.numberTable}</TableCell>
                                                    <TableCell className="header-th">{GeneralTranslations.documentNameTable}</TableCell>
                                                    <TableCell className="header-th"></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {savedDocuments.map((doc, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell >{index + 1}</TableCell>
                                                        <TableCell >{doc.file.name}</TableCell>
                                                        <TableCell >  <Button size='xs' className="btn-clear-table" onClick={() => handleDelete(index)} >{ControlsTranslations.Delete}</Button></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </div>
                                )}
                            </div>
                        </Stepper.Completed>
                    </Stepper>
                    <div className="apk-form-background">
                        <div className='logo'> <img src="/img/logo/web/logo-gray.png" alt="Logo" /></div>
                    </div>
                    <Link className='back-btn' to="/">{GeneralTranslations.BackToHome}</Link>
                </div >


                <div className="stepper-footer">
                    <Group justify="end" mt="xl">
                        {active >= 1 &&
                            <Button type="button" className="form-btn-back btn-base" variant="default" onClick={prevStep}>{ControlsTranslations.BackButton2}</Button>
                        }
                        <Button
                            type="submit"
                            leftSection={active === 2 && <FaCheck />}
                            className="form-btn btn-base"
                            onClick={() => {
                                handleNextStep();
                            }}
                        >
                            {isLoading ? ControlsTranslations.generate : active === 2 ? ControlsTranslations.complete : active === 1 ? ControlsTranslations.Send : ControlsTranslations.continue}
                        </Button>
                    </Group>
                </div>
            </div >
            {
                active === 2 && referenceDeklarimi &&
                <Modal
                    className="raport-modal"
                    opened={true}
                    centered
                    size="lg"
                    withCloseButton={false}
                    // onClose={close}
                    overlayProps={{
                        backgroundOpacity: 0.55,
                        blur: 3,
                    }}
                >
                    <div className="completed-step">
                        <div className="completed-box">
                            <div className="text-content">
                                <Title className="form-title" order={2}>{GeneralTranslations.succes}</Title>
                                <Text className="form-desc" size="md">
                                    {GeneralTranslations.subjectNumber}
                                    <CopyToClipboard text={referenceDeklarimi}>
                                        <Text
                                            td="underline"
                                            span
                                            c="blue"
                                            inherit
                                        >
                                            {referenceDeklarimi}
                                        </Text>
                                    </CopyToClipboard>
                                </Text>
                            </div>

                            <div className="completed-footer">
                                <Group justify="end">
                                    <Button className="form-btn-back btn-base">
                                        <a
                                            href={`${baseUrl}Reports/GetDeclarationReport?type=1&ReferencaRaportimit=${referenceDeklarimi}&webLangId=${languageValue}`}
                                            target="_blank"
                                        >
                                            {ControlsTranslations.download}
                                        </a>
                                    </Button>
                                    <Button className="form-btn btn-base" variant="default" onClick={handlePopup}>{ControlsTranslations.finish}</Button>
                                </Group>

                            </div>

                        </div>
                    </div>
                </Modal>
            }
            <Modal
                className="raport-modal"
                opened={documentsModelOpen}
                centered
                size="lg"
                withCloseButton={false}
                onClose={closeModalDocuments}
                overlayProps={{
                    backgroundOpacity: 0.55,
                    blur: 3,
                }}
            >
                <div className="completed-step">
                    <div className="completed-box">
                        <div className="text-content">
                            <Title className="form-title flex items-center gap-2" order={2}><FaInfoCircle color='#051A53' />  {AlertTranslations.AreYouSure}</Title>
                            <Text className="form-desc" size="md">
                                {AlertTranslations.AreYouSureDescription}
                            </Text>
                        </div>
                        <div className="completed-footer">
                            <Group justify="end">
                                <Button className="form-btn-back btn-base" variant="outline" onClick={closeModalDocuments}>
                                    {ControlsTranslations.no}
                                </Button>
                                <Button className="form-btn btn-base" variant="default" color="red" onClick={confirmDeleteDocuments}>
                                    {ControlsTranslations.yes}
                                </Button>
                            </Group>

                        </div>
                    </div>
                </div>
            </Modal>
            <div className="notification-cm">
                {NotificationBox}
            </div>
        </div >
    )
}

export default Deklarimi